import PropTypes from "prop-types";
import React from "react";

import { Image, StyleSheet } from "react-native";
import { connect } from "react-redux";

import { STATIC_CARD_NUMBERS } from "../components/DependencyDetail";

const AVATARS = {
  f: [
    require("../assets/avatars/girl/1.png"),
    require("../assets/avatars/girl/2.png"),
    require("../assets/avatars/girl/3.png"),
    require("../assets/avatars/girl/4.png"),
    require("../assets/avatars/girl/5.png"),
    require("../assets/avatars/girl/6.png"),
    require("../assets/avatars/girl/7.png"),
    require("../assets/avatars/girl/8.png"),
    require("../assets/avatars/girl/9.png"),
    require("../assets/avatars/girl/10.png"),
    require("../assets/avatars/girl/11.png"),
    require("../assets/avatars/girl/12.png"),
    require("../assets/avatars/girl/13.png"),
    require("../assets/avatars/girl/14.png"),
    require("../assets/avatars/girl/15.png"),
    require("../assets/avatars/girl/16.png"),
    require("../assets/avatars/girl/17.png"),
    require("../assets/avatars/girl/18.png"),
    require("../assets/avatars/girl/19.png"),
    require("../assets/avatars/girl/20.png"),
    require("../assets/avatars/girl/21.png"),
    require("../assets/avatars/girl/22.png"),
    require("../assets/avatars/girl/23.png"),
    require("../assets/avatars/girl/24.png"),
    require("../assets/avatars/girl/25.png"),
    require("../assets/avatars/girl/26.png"),
    require("../assets/avatars/girl/27.png"),
  ],
  m: [
    require("../assets/avatars/boy/1.png"),
    require("../assets/avatars/boy/2.png"),
    require("../assets/avatars/boy/3.png"),
    require("../assets/avatars/boy/4.png"),
    require("../assets/avatars/boy/5.png"),
    require("../assets/avatars/boy/6.png"),
    require("../assets/avatars/boy/7.png"),
    require("../assets/avatars/boy/8.png"),
    require("../assets/avatars/boy/9.png"),
    require("../assets/avatars/boy/10.png"),
    require("../assets/avatars/boy/11.png"),
    require("../assets/avatars/boy/12.png"),
    require("../assets/avatars/boy/13.png"),
    require("../assets/avatars/boy/14.png"),
    require("../assets/avatars/boy/15.png"),
    require("../assets/avatars/boy/16.png"),
    require("../assets/avatars/boy/17.png"),
    require("../assets/avatars/boy/18.png"),
    require("../assets/avatars/boy/19.png"),
    require("../assets/avatars/boy/20.png"),
    require("../assets/avatars/boy/21.png"),
    require("../assets/avatars/boy/22.png"),
    require("../assets/avatars/boy/23.png"),
  ],
};

const STATIC_AVATARS = {
  parents: require("../assets/avatars/parents.png"),
  partner: require("../assets/avatars/partner.png"),
  children: require("../assets/avatars/children.png"),
};

class DependencyAvatar extends React.Component {
  static propTypes = {
    cardNumber: PropTypes.string.isRequired,
    gender: PropTypes.oneOf(["f", "m", ""]).isRequired,
  };

  state = {
    avatarImg: null,
  };

  selectAvatar() {
    const { cardNumber, gender } = this.props;
    const isStatic = STATIC_CARD_NUMBERS.includes(cardNumber);

    if (isStatic) {
      this.setState({
        avatarImg: STATIC_AVATARS[cardNumber],
      });
    } else {
      const seed = cardNumber
        .split("")
        .reduce(
          (currentSeed, c) =>
            (currentSeed + c.charCodeAt(0)) % AVATARS[gender].length,
          0
        );
      this.setState({
        avatarImg: AVATARS[gender][seed],
      });
    }
  }

  componentDidMount() {
    this.selectAvatar();
  }

  render() {
    const { cardNumber, gender, themeColors } = this.props;
    const { avatarImg } = this.state;

    return (
      <Image
        source={avatarImg}
        style={[
          styles.avatar,
          {
            backgroundColor: themeColors.lightestPrimary,
          },
        ]}
      />
    );
  }
}

const styles = StyleSheet.create({
  avatar: {
    borderRadius: 30,
    height: 60,
    width: 60,
  },
});

export default connect((state) => ({
  themeColors: state.themeColors,
}))(DependencyAvatar);
